import { FC } from 'react'
import { IconProps } from '@/root/shared-types/ui/ui-types'

// Inline SVG so the glyph inherits the parent's text colour via `currentColor` (e.g. white on a
// coloured stepper button) and centres by layout instead of a font-specific pixel nudge.
export const PlusIcon: FC<IconProps> = ({ width = 18, height = 18, className }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    aria-hidden
    focusable="false"
  >
    <path d="M12 7v10M7 12h10" stroke="currentColor" strokeWidth={3} strokeLinecap="round" />
  </svg>
)
